var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-section"},[_vm._v(" "+_vm._s(_vm.title)+" "),(!_vm.$slots.default)?_c('span',{staticClass:"m-section-subTitle"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }